/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScimAttributeMappingConfigurationRequest
 */
export interface ScimAttributeMappingConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof ScimAttributeMappingConfigurationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ScimAttributeMappingConfigurationRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ScimAttributeMappingConfigurationRequest
     */
    companyTarget?: string;
}

/**
 * Check if a given object implements the ScimAttributeMappingConfigurationRequest interface.
 */
export function instanceOfScimAttributeMappingConfigurationRequest(value: object): value is ScimAttributeMappingConfigurationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ScimAttributeMappingConfigurationRequestFromJSON(json: any): ScimAttributeMappingConfigurationRequest {
    return ScimAttributeMappingConfigurationRequestFromJSONTyped(json, false);
}

export function ScimAttributeMappingConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScimAttributeMappingConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'companyTarget': json['companyTarget'] == null ? undefined : json['companyTarget'],
    };
}

export function ScimAttributeMappingConfigurationRequestToJSON(value?: ScimAttributeMappingConfigurationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'companyTarget': value['companyTarget'],
    };
}

